var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgValorLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 504 151.03",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #011ca3;\n      }\n\n      .cls-1, .cls-2, .cls-3 {\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        fill: #06b96d;\n      }\n\n      .cls-3 {\n        fill: #191919;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Valor"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Logo_2.0",
    "data-name": "Logo 2.0"
  }, /*#__PURE__*/React.createElement("path", {
    id: "P",
    className: "cls-3",
    d: "M199.14,116.49c3.41-.29,6.81.63,9.61,2.58,2.09,1.86,3.21,4.58,3.03,7.37,0,1.4-.24,2.79-.72,4.11-.48,1.31-1.27,2.48-2.29,3.42-1.2,1.07-2.62,1.86-4.15,2.33-2.04.61-4.16.9-6.29.85h-4.13v13.39h-3.95v-34.05h8.87ZM198.77,119.87h-4.55v13.88h3.7c1.83.04,3.66-.19,5.43-.7,1.31-.37,2.46-1.17,3.27-2.27.78-1.25,1.17-2.71,1.09-4.18.14-1.94-.66-3.83-2.16-5.07-2.02-1.27-4.39-1.85-6.76-1.67"
  }), /*#__PURE__*/React.createElement("path", {
    id: "A",
    className: "cls-3",
    d: "M260.2,150.53l-4.18-10.81h-13.62l-4.16,10.81h-4l13.3-34.19h3.56l13.2,34.19h-4.1ZM254.84,136.21l-3.97-10.74c-.09-.28-.24-.74-.45-1.37s-.42-1.3-.64-1.98-.4-1.23-.54-1.65c-.16.64-.33,1.27-.5,1.91-.18.63-.35,1.21-.52,1.75s-.32.99-.44,1.36l-4.05,10.74h11.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Y",
    className: "cls-3",
    d: "M297.66,133.56l9.04-17.07h4.25l-11.32,20.85v13.21h-3.95v-13.02l-11.34-21.03h4.32l9,17.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "T",
    className: "cls-3",
    d: "M346.04,150.54h-3.97v-30.55h-10.69v-3.49h25.31v3.49h-10.65v30.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "E",
    className: "cls-3",
    d: "M400.74,150.54h-18.92v-34.05h18.92v3.49h-14.97v11.01h14.11v3.45h-14.11v12.6h14.97v3.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "C",
    className: "cls-3",
    d: "M442.79,119.49c-1.73-.03-3.45.3-5.06.97-1.47.62-2.78,1.58-3.82,2.8-1.09,1.3-1.91,2.8-2.41,4.41-1.27,4.36-1.09,9.01.5,13.26.8,2,2.2,3.7,4,4.88,2,1.21,4.32,1.81,6.66,1.72,1.44,0,2.88-.12,4.3-.38,1.32-.25,2.63-.57,3.92-.95v3.45c-1.26.47-2.57.82-3.91,1.04-1.61.24-3.23.36-4.86.34-3.03.11-6.03-.63-8.66-2.15-2.32-1.44-4.14-3.57-5.21-6.09-1.22-2.94-1.81-6.11-1.73-9.29-.03-2.4.34-4.79,1.08-7.07.67-2.04,1.74-3.92,3.16-5.53,1.41-1.57,3.16-2.8,5.11-3.6,2.21-.88,4.58-1.31,6.96-1.27,1.67,0,3.34.17,4.97.51,1.5.31,2.95.8,4.32,1.47l-1.58,3.35c-1.15-.52-2.35-.95-3.57-1.29-1.37-.37-2.78-.56-4.2-.55"
  }), /*#__PURE__*/React.createElement("path", {
    id: "H",
    className: "cls-3",
    d: "M504,150.54h-3.95v-16.05h-17.85v16.05h-3.95v-34.05h3.95v14.51h17.85v-14.51h3.95v34.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "V",
    className: "cls-3",
    d: "M195.43,99.95c-2.22.03-4.25-1.27-5.16-3.29l-24.55-65.76h12.52l17.23,45.23,17.56-45.28h12.56l-24.92,65.88c-.98,2-3.03,3.25-5.25,3.22"
  }), /*#__PURE__*/React.createElement("path", {
    id: "A-2",
    "data-name": "A",
    className: "cls-3",
    d: "M274.4,99.43l-17.56-45.28-17.23,45.23h-12.52l24.55-65.75c.92-2.02,2.94-3.31,5.16-3.29,2.26-.03,4.32,1.27,5.28,3.31l24.89,65.79h-12.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "L",
    className: "cls-3",
    d: "M317.55,99.43c-8.03,0-11.77-4.08-11.77-12.85V30.74h12.92v56.86h30.13v11.83h-31.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "O",
    className: "cls-3",
    d: "M392.39,99.95c-16.18,0-24.05-11.4-24.05-34.85s7.88-34.85,24.05-34.85h11.4c16.18,0,24.05,11.4,24.05,34.85s-7.88,34.85-24.05,34.85h-11.4ZM397.17,42.06c-7.28.05-15.97,3.38-15.97,18.89v8.8c.11,15.8,9.21,18.66,17.32,18.53,7.5,0,16.45-3.22,16.45-18.53v-8.8c-.24-16.57-9.21-19.1-17.8-18.89"
  }), /*#__PURE__*/React.createElement("path", {
    id: "R",
    className: "cls-3",
    d: "M488.31,99.43l-11.49-22.57c-2.5-5.15-2.59-9.05-.24-11.9l11.86-14.29c1.22-1.34,1.91-3.08,1.94-4.9.04-2.09-1.62-3.82-3.71-3.86-.21,0-.41,0-.61.04h-23.66v57.48h-12.41l-.05-68.74h36.31c4.23-.19,8.35,1.32,11.46,4.19,6.3,5.81,5.77,18.44-.87,24.51l-.1.11s-6.4,7.56-6.42,7.6c-1.52,2.04-1.77,4.76-.65,7.05l14.06,25.28h-15.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shield_V",
    "data-name": "Shield V",
    className: "cls-1",
    d: "M127.16,68.58c-9.35,34.09-31.1,63.46-60.99,82.34-29.88-18.89-51.62-48.25-60.98-82.34l14.25-6.82c11.49,19.65,27.51,36.26,46.74,48.45,19.23-12.19,35.26-28.8,46.75-48.45l14.23,6.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shield_Arrow",
    "data-name": "Shield Arrow",
    className: "cls-2",
    d: "M128.89,61.75l-12.63-6.07-50.07-24-50.08,24-12.63,6.07C1.08,51.92-.08,41.84,0,31.72l5.53-2.65L66.19,0l60.63,29.08,5.54,2.65c.09,10.11-1.08,20.2-3.47,30.02"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgValorLogo);
export default __webpack_public_path__ + "static/media/ValorLogo.99d87e468947a3933d3ba5c6c4f215b4.svg";
export { ForwardRef as ReactComponent };